import React, {memo, useState} from 'react'
import Typography from '@material-ui/core/Typography'
import MailIcon from '@material-ui/icons/Mail';
import OutlinedFlagRoundedIcon from '@material-ui/icons/OutlinedFlagRounded';
import DoubleArrowIcon from '@material-ui/icons/DoubleArrow';
import FlagRoundedIcon from '@material-ui/icons/FlagRounded';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import {Badge, Checkbox, makeStyles, Tooltip} from "@material-ui/core";
import ExpansionPanel from "../../ExpansionPanel";
import Tr from "translations/Translations";
import GridBlock from "../../GridBlock";
import clsx from 'clsx';
import CorrespondenceService from "../../../services/CorrespondenceService";
import MessagesList from "./MessagesList";
import scrollTo from "../../../libs/scrollTo";
import WorkableIconButton from "../../button/WorkableIconButton";
import WorkableIconExpandButton from "components/button/WorkableIconExpandButton";
import IconButton from "../../button/IconButton";

const useStyles = makeStyles(theme => ({
    root: {
        marginBottom: theme.spacing(2)

    },
    rootExpanded: {
        marginBottom: `${theme.spacing(2)}px !important`
    },
    title: {
        padding: 0,
    },
    summaryRoot: {
        '&>*:nth-child(3)': {
            flexGrow: 1,
           //paddingLeft: theme.spacing(2),
            width: 0,
        }
    },
    summaryItem: {
        padding: "0 " + theme.spacing(1) + "px"
    },
    subject: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    },
    subjectExpanded: {
        wordBreak: 'break-all'
    },
    avatar: {
        width: 30,
        height: 30,
        marginRight: theme.spacing(2)
    },
    member: {
        width: '200px',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis'
    },
    hasUnread: {
        fontWeight: theme.typography.fontWeightBold
    },
    redFlag: {
        width: 10,
        color: theme.palette.error.main
    },
    publicQuestion: {
        color: theme.palette.black
    },
    draftWarning: {
        margin: 0,
        color: theme.palette.error.main
    }
}));


function Thread(
    {
        thread,
        rfxRoundId,
        contractor,
        onThreadSelectChange = () => {
        },
        selectedThreads,
        listResourceId,
        currentActive,
        hasUnsentMessages
    }) {

    const classes = useStyles();

    const [expanded, setExpanded] = useState(!!thread.messages);
    const [redFlagWorking, setRedFlagWorking] = useState(false);
    const [loadingMessagesWorking, setLoadingMessagesWorking] = useState(false);
    const threadSelected = selectedThreads.indexOf(thread.threadId) > -1;

    const selectThreadChange = (e) => {
        onThreadSelectChange(thread, e.target.checked);
    }

    const toggleThread = (callback) => {
        if(loadingMessagesWorking) {
            return;
        }

        setExpanded(!expanded);
        if(expanded) {
            CorrespondenceService.clearThreadMessages(thread.threadId, listResourceId);
        } else {
            setLoadingMessagesWorking(true);
            if(contractor) {
                CorrespondenceService.getContractorThreadMessageList(rfxRoundId, thread.threadId, listResourceId).then(()=> { if(typeof callback === 'function')setTimeout(callback, 500)}).catch(()=> setExpanded(false)).finally(()=> setLoadingMessagesWorking(false));
            } else {
                CorrespondenceService.getBuyerThreadMessageList(rfxRoundId, thread.threadId, listResourceId).then(()=> { if(typeof callback === 'function')setTimeout(callback, 500)}).catch(()=> setExpanded(false)).finally(()=> setLoadingMessagesWorking(false));
            }

        }
    }

    const scrollToMessage = () => {
        if(loadingMessagesWorking) {
            return;
        }
        if(expanded) {
            doScrollToMessage();
        } else {
            toggleThread(doScrollToMessage)
        }

    }
    const doScrollToMessage = () => {
        scrollTo(`#messate-thread-${thread.threadId} .new-message-scroll-to`);
    }

    const flagClick = () => {
        setRedFlagWorking(true);
        let fn;
        if (thread.hasRedFlag) {
            fn = contractor ? CorrespondenceService.sendContractorUnflagThread : CorrespondenceService.sendBuyerUnflagThread;
        } else {
            fn = contractor ? CorrespondenceService.sendContractorFlagThread : CorrespondenceService.sendBuyerFlagThread;
        }
        fn(rfxRoundId, thread.threadId, listResourceId).finally(() => setRedFlagWorking(false));
    }


    const createTitle = ({threadId, hasRedFlag, subject, recipients, unreadMessagesCount = 0, createdByLoggedInUser, publicQuestion}) => {
        const hasThreadUnsentMessages = !!hasUnsentMessages || !!thread.messages?.some(message => message.status === 'saved');
        return (
            <GridBlock alignItems="center" wrap='nowrap' justify='space-between' gridClasses={{root: classes.summaryRoot, item: classes.summaryItem}}>
                <Tooltip title={threadSelected ? Tr('checkbox_uncheck') : Tr('checkbox_check')}>
                    <Checkbox
                        color='primary'
                        checked={threadSelected}
                        onChange={selectThreadChange}
                        disabled={false}
                    />
                </Tooltip>
                {!contractor ?
                <Typography className={clsx(classes.member, {[classes.hasUnread]: !!unreadMessagesCount})} variant='h6' onClick={toggleThread}>
                    {recipients.map(x => x.name).join(", ")}
                </Typography> : <Typography />}
                <Typography className={clsx({
                    [classes.subjectExpanded]: expanded,
                    [classes.subject]: !expanded,
                    [classes.hasUnread]: !!unreadMessagesCount
                })
                } variant='h6' onClick={toggleThread}>
                    {subject}
                </Typography>
                {!!unreadMessagesCount && <div>
                    <Badge badgeContent={unreadMessagesCount} max={9} color="error">
                        <MailIcon color='primary' onClick={scrollToMessage}/>
                    </Badge>
                </div>}
                {!!(publicQuestion) &&
                    <IconButton className={classes.publicQuestion} Icon={DoubleArrowIcon} tooltip={createdByLoggedInUser ? Tr('public_question_logged_in_user') : Tr("public_question")}
                                        />
                }
                {hasThreadUnsentMessages &&
                    <IconButton className={classes.draftWarning} Icon={ErrorOutlineIcon} tooltip={Tr('correspondence_contains_unsent_messages')} />
                }
                <WorkableIconButton className={classes.redFlag} Icon={hasRedFlag ? FlagRoundedIcon : OutlinedFlagRoundedIcon} tooltip={hasRedFlag ? Tr('unflag') : Tr("flag")}
                                    onClick={flagClick} working={redFlagWorking}/>
                <WorkableIconExpandButton
                    color='primary'
                    onClick={toggleThread}
                    expanded={expanded}
                />
            </GridBlock>
        )
    }

    return (
        <ExpansionPanel
            titleAdornment={createTitle(thread)}
            expanded={expanded}
            onChange={(event, expanded) => {
                if (event === null) setExpanded(expanded)
            }}
            classesObj={{root: classes.root, expanded: classes.rootExpanded, title: classes.title}}
            square={true}
            id={`messate-thread-${thread.threadId}`}>
            <MessagesList listResourceId={listResourceId} rfxRoundId={rfxRoundId} thread={thread} contractor={contractor} currentActive={currentActive}/>
        </ExpansionPanel>
    )
}

export default memo(Thread, (prevProps, nextProps) => {
    //const t0 = performance.now()
    const resp = ((prevProps, nextProps) => {
        if (prevProps.rfxRoundId !== nextProps.rfxRoundId) return false;
        if (prevProps.currentActive !== nextProps.currentActive) return false;
        if (prevProps.hasUnsentMessages !== nextProps.hasUnsentMessages) return false;

        if(prevProps.selectedThreads !== nextProps.selectedThreads) {
            if ((prevProps.selectedThreads.indexOf(prevProps.thread.threadId) > -1) !== (nextProps.selectedThreads.indexOf(nextProps.thread.threadId) > -1)) return false;
        }

        if(prevProps.thread !== nextProps.thread) {
            return false;
        }

        return true;
    })(prevProps, nextProps);
    // const t1 = performance.now()
    // console. log("Thread rerender", !resp);
    return resp;
})